// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WhaIGet_wrapper__1m18y","basic":"WhaIGet_basic__25YGn","professional":"WhaIGet_professional__uKTz4","premium":"WhaIGet_premium__36E_q"};